<!--
 * @Author: wh
 * @Date: 2020-07-03 11:10:22
 * @LastEditTime: 2020-07-18 18:42:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\salesTerminal\retailAccount\newMaintain.vue
-->
<template>
    <div class="newMaintain">
        <van-nav-bar
            title="新建"
            left-text=""
            right-text="保存"
            left-arrow
            @click-left="onClickLeft"
            @click-right="onClickRight"
        ></van-nav-bar>
        <section class="van-pull-refresh">
            <van-field
                :left-icon="require('@/assets/images/icons/icon_gy_3.png')"
                label="维护类型"
                placeholder="请选择"
                input-align="right"
                readonly
                clickable
                name="picker"
                is-link
                @click="showPopup('maintenance_type')"
                v-model="formData.maintenance_type_name"
            >
            </van-field>
            <van-action-sheet
                v-model="showActionSheet"
                :actions="columns"
                @select="actionConfirm"
                :style="{height: '30%'}"
            ></van-action-sheet>
            <van-field
                :left-icon="require('@/assets/images/icons/icon_6.png')"
                label="方量（m³）"
                placeholder="请输入方量"
                input-align="right"
                v-model="formData.capacity"
            >
            </van-field>
            <van-field
                :left-icon="require('@/assets/images/icons/icon_26.png')"
                label="金额（万元）"
                placeholder="请输入金额"
                input-align="right"
                v-model="formData.amount_money"
            >
            </van-field>
            <van-field
                :left-icon="require('@/assets/images/icons/icon_gy_3.png')"
                label="支付方式"
                placeholder="请选择"
                input-align="right"
                readonly
                clickable
                name="picker"
                is-link
                @click="showPopup('payment_mode')"
                v-model="formData.payment_mode_name"
            >
            </van-field>
        </section>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    components: {},
    props: {},
    data() {
        return {
            // 表单数据
            formData: {},
            // 下拉列表
            showActionSheet: false,
            originalColumns: [],
            columns: [],
            // 维护类型
            maintenanceTypeOriginalColumns: [],
            maintenanceTypeColumns: [],
            // 支付方式
            paymentModeOriginalColumns: [],
            paymentModeColumns: [],
            // 合同id
            cvid: '',
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 返回上级页面
        onClickLeft() {
            const cvid = this.$route.params.cvid;
            this.$router.isBack = 1;
            this.$router.replace({ name: 'retailAccountMaintain', params: { cvid: cvid } });
            this.$router.go(-1);
        },
        // 保存数据
        onClickRight() {
            this.$axios
                .post('/interfaceApi/sale/contract_manager/add_maintenance', this.formData)
                .then(res => {
                    if (res) {
                        this.$router.isBack = 1;
                        this.$router.replace({ name: 'retailAccountMaintain', params: { cvid: this.$route.params.cvid } });
                        this.$router.go(-1);
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 展示下拉选择
        showPopup(type) {
            this.actionType = type;
            switch (type) {
                case 'maintenance_type': // 维护类型
                    if (this.maintenanceTypeColumns.length > 0) {
                        this.columns = this.maintenanceTypeColumns;
                        this.showActionSheet = true;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                case 'payment_mode': // 支付方式
                    if (this.paymentModeColumns.length > 0) {
                        this.columns = this.paymentModeColumns;
                        this.showActionSheet = true;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                default:
                    // 默认代码块;
            }
        },
        // 确认选择
        actionConfirm(data) {
            let obj = [];
            switch (this.actionType) {
                // 维护类型
                case 'maintenance_type':
                    this.formData.maintenance_type_name = data.name;
                    obj = this.maintenanceTypeOriginalColumns.filter(item => item.dic_name === data.name);
                    this.formData.maintenance_type = obj[0].dic_code;
                    this.showActionSheet = false;
                    break;
                // 支付方式
                case 'payment_mode':
                    this.formData.payment_mode_name = data.name;
                    obj = this.paymentModeOriginalColumns.filter(item => item.name === data.name);
                    this.formData.payment_mode = obj[0].code;
                    this.showActionSheet = false;
                    break;
                default:
                    // 默认代码块;
            }
        },
        // 拉取字典列表
        getMaintenanceType() {
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_dictionary?groupCode=maintenance_type')
                .then(res => {
                    if (res) {
                        res.map(item => {
                            this.maintenanceTypeColumns.push({ name: item.dic_name });
                            this.maintenanceTypeOriginalColumns.push(item);
                        });
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取下拉框数据列表
        getCategory() {
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=601-FK0')
                .then(res => {
                    if (res) {
                        res.map(item => {
                            this.paymentModeColumns.push({ name: item.name });
                            this.paymentModeOriginalColumns.push(item);
                        });
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
    },
    created() {},
    mounted() {
        this.cvid = this.$route.params.cvid;
        this.formData.contract_version_id = this.cvid;
        this.getMaintenanceType();
        this.getCategory();
    },
};
</script>
<style lang="stylus" scoped>
.newMaintain{}
</style>
